import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function GoogleCallback() {
  const location = useLocation();

  useEffect(() => {
    // Imprime los parámetros recibidos para depuración
    console.log("Parámetros recibidos:", location.search);

    const params = new URLSearchParams(location.search);
    // Capturamos el token desde id_token en lugar de jwt
    const idToken = params.get("id_token");
    const userData = params.get("user");

    // Detección precisa de entorno
    const isProduction = window.location.hostname === 'www.workingunidos.com';
    const baseUrl = isProduction 
      ? 'https://www.workingunidos.com' 
      : 'http://localhost:5173';

    if (idToken) {
      localStorage.setItem("jwt", idToken); // Si deseas mantener la llave "jwt" en localStorage

      if (userData) {
        try {
          const parsedUser = JSON.parse(decodeURIComponent(userData));
          if (parsedUser?.id) { // Validación crítica
            localStorage.setItem("user", JSON.stringify(parsedUser));
            if (parsedUser.userType) {
              localStorage.setItem("userType", parsedUser.userType.toLowerCase());
            }
          }
        } catch (error) {
          console.error("Error al parsear datos del usuario:", error);
        }
      }

      const redirectPath = localStorage.getItem("savedPath") || "/mi-cuenta";
      window.location.href = `${baseUrl}${redirectPath}`;
    } else {
      const errorMessage = params.get("error") || "Error desconocido en Google";
      console.error("Error en GoogleCallback:", errorMessage);
      window.location.href = `${baseUrl}/login?error=${encodeURIComponent(errorMessage)}`;
    }

    localStorage.removeItem("savedPath");
  }, [location]);

  return (
    <div className="container my-5 text-center">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Cargando...</span>
      </div>
      <p className="mt-3">Procesando autenticación con Google...</p>
    </div>
  );
}

export default GoogleCallback;